export const PADDING_MODIFIER_OPTIONS = [
  { value: 0, label: "None" },
  { value: 1, label: "1px" },
  { value: 2, label: "2px" },
  { value: 4, label: "4px" },
  { value: 6, label: "6px" },
  { value: 8, label: "8px" },
  { value: 10, label: "10px" },
  { value: 12, label: "12px" },
  { value: 16, label: "16px" },
  { value: 20, label: "20px" },
  { value: 24, label: "24px" },
  { value: 32, label: "32px" },
  { value: 40, label: "40px" },
  { value: 48, label: "48px" },
];

export const MARGIN_MODIFIER_OPTIONS: {
  value: number | "auto";
  label: string;
}[] = [
  { value: "auto", label: "Auto" },
  { value: 0, label: "None" },
  { value: 1, label: "1px" },
  { value: 2, label: "2px" },
  { value: 4, label: "4px" },
  { value: 6, label: "6px" },
  { value: 8, label: "8px" },
  { value: 10, label: "10px" },
  { value: 12, label: "12px" },
  { value: 16, label: "16px" },
  { value: 20, label: "20px" },
  { value: 24, label: "24px" },
  { value: 32, label: "32px" },
  { value: 40, label: "40px" },
  { value: 48, label: "48px" },
];

export const GAP_MODIFIER_OPTIONS = [
  { value: 0, label: "None" },
  { value: 1, label: "1px" },
  { value: 2, label: "2px" },
  { value: 4, label: "4px" },
  { value: 6, label: "6px" },
  { value: 8, label: "8px" },
  { value: 12, label: "12px" },
  { value: 16, label: "16px" },
  { value: 20, label: "20px" },
  { value: 24, label: "24px" },
  { value: 32, label: "32px" },
  { value: 40, label: "40px" },
  { value: 48, label: "48px" },
  { value: 64, label: "64px" },
];

export const TEXT_SPACING_OPTIONS = [
  { value: -0.1, label: "Tightest", displayValue: "Tightest" },
  { value: -0.05, label: "Tighter", displayValue: "Tighter" },
  { value: -0.025, label: "Tight", displayValue: "Tight" },
  { value: 0, label: "Normal", displayValue: "Normal" },
  { value: 0.025, label: "Wide", displayValue: "Wide" },
  { value: 0.05, label: "Wider", displayValue: "Wider" },
  { value: 0.1, label: "Widest", displayValue: "Widest" },
];

export const LINE_HEIGHT_OPTIONS = [
  { value: null, label: "Auto", displayValue: "Auto" },
  { value: 1.25, label: "Tight", displayValue: "Tight" },
  { value: 1.375, label: "Snug", displayValue: "Snug" },
  { value: 1.5, label: "Normal", displayValue: "Normal" },
  { value: 1.625, label: "Relaxed", displayValue: "Relaxed" },
  { value: 2, label: "Loose", displayValue: "Loose" },
];

export const OPACITY_OPTIONS = [
  { value: "0", label: "0%" },
  { value: "25", label: "25%" },
  { value: "50", label: "50%" },
  { value: "75", label: "75%" },
  { value: "100", label: "100%" },
];

export const FONT_SIZE_OPTIONS: { value: string | null; label: string }[] = [
  { value: null, label: "Auto" },
  { value: "10", label: "10px" },
  { value: "12", label: "12px" },
  { value: "14", label: "14px" },
  { value: "16", label: "16px" },
  { value: "18", label: "18px" },
  { value: "20", label: "20px" },
  { value: "24", label: "24px" },
  { value: "30", label: "30px" },
  { value: "36", label: "36px" },
  { value: "48", label: "48px" },
  { value: "60", label: "60px" },
  { value: "72", label: "72px" },
];

// NOTE (Kevin, 2025-12-16): Object fit options for image/video elements.
// Values correspond to CSS object-fit property and Tailwind object-* classes.
export const OBJECT_FIT_OPTIONS = [
  { value: "cover", label: "Cover", displayValue: "Cover" },
  { value: "contain", label: "Contain", displayValue: "Contain" },
  { value: "fill", label: "Fill", displayValue: "Fill" },
  { value: "none", label: "None", displayValue: "None" },
  { value: "scale-down", label: "Scale Down", displayValue: "Scale Down" },
] as const;
